import { render, staticRenderFns } from "./PolygonPopup.vue?vue&type=template&id=152abc99&"
import script from "./PolygonPopup.vue?vue&type=script&lang=js&"
export * from "./PolygonPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports